import React from "react";
import { Chip } from "./Chip";
import { PURPOSES, TRADING, HOMEOWNER_OPTIONS, inputCls } from "./constants";

export const Step2LoanDetails = ({ form, onSet }) => (
  <div className="space-y-6">
    <div>
      <p className="text-[11px] font-bold tracking-[0.2em] text-[#052F24]/50 uppercase mb-3">What's it for?</p>
      <div className="flex flex-wrap gap-2.5">
        {PURPOSES.map((p) => (
          <Chip key={p} active={form.loan_purpose === p} onClick={() => onSet("loan_purpose", p)} testId={`purpose-${p}`}>
            {p}
          </Chip>
        ))}
      </div>
    </div>
    <div>
      <p className="text-[11px] font-bold tracking-[0.2em] text-[#052F24]/50 uppercase mb-3">How long trading?</p>
      <div className="flex flex-wrap gap-2.5">
        {TRADING.map((t) => (
          <Chip key={t} active={form.trading_time === t} onClick={() => onSet("trading_time", t)} testId={`trading-${t}`}>
            {t}
          </Chip>
        ))}
      </div>
    </div>
    <div>
      <p className="text-[11px] font-bold tracking-[0.2em] text-[#052F24]/50 uppercase mb-3">Are you a homeowner? *</p>
      <div className="flex flex-wrap gap-2.5">
        {HOMEOWNER_OPTIONS.map((h) => (
          <Chip key={h} active={form.homeowner === h} onClick={() => onSet("homeowner", h)} testId={`homeowner-${h}`}>
            {h}
          </Chip>
        ))}
      </div>
    </div>
    <div className="grid grid-cols-2 gap-4">
      <input
        className={inputCls}
        placeholder="Annual turnover (£) *"
        value={form.annual_turnover}
        onChange={(e) => onSet("annual_turnover", e.target.value)}
        data-testid="input-turnover"
        required
      />
      <input
        className={inputCls}
        placeholder="Monthly sales (£) *"
        value={form.monthly_sales}
        onChange={(e) => onSet("monthly_sales", e.target.value)}
        data-testid="input-monthly-sales"
        required
      />
    </div>
  </div>
);
